import { render } from "./UsuariosSite.vue?vue&type=template&id=89d453f2"
import script from "./UsuariosSite.vue?vue&type=script&lang=js"
export * from "./UsuariosSite.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__